import React from "react";
import "./style/app.scss";
import { PresentationList } from "./components/presentationList";
import { Route, BrowserRouter as Router } from "react-router-dom";
import presentations from "./slides/index";
import {
	QueryStringParams,
	SlideShowPage,
} from "./components/slideShowPage/SlideShowPage";
import { DownloadSlideShowPage } from "./components/downloadSlideShowPage";
import { SpeakerNotesPage } from "./components/speakerNotesPage/index.";

interface RouteProps {
	match: QueryStringParams;
}

const App = () => {
	return (
		<>
			<Router>
				<Route
					exact={true}
					path="/"
					component={(routeProps: RouteProps) => (
						<PresentationList
							presentations={presentations}
							{...routeProps}
						/>
					)}
				></Route>
				<Route
					exact={true}
					path="/present/:name/:slide?"
					component={(routeProps: RouteProps) => (
						<SlideShowPage
							presentations={presentations}
							{...routeProps}
						/>
					)}
				></Route>
				<Route
					exact={true}
					path="/download/:name"
					component={(routeProps: RouteProps) => (
						<DownloadSlideShowPage
							presentations={presentations}
							{...routeProps}
						/>
					)}
				></Route>

				<Route
					exact={true}
					path="/notes/:channel"
					component={(routeProps: RouteProps) => (
						<SpeakerNotesPage {...routeProps} />
					)}
				></Route>
			</Router>
		</>
	);
};

export { App };
